<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Contact</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <!-- <vs-button
              @click="editContact"
              icon="edit"
              color="danger"
              type="border"
              >Edit</vs-button
            > -->
          </vs-col>
        </vs-row>
        <vs-divider class="m-5" />

        <div class="vx-row mb-6" v-if="contactDescription.company_name">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Company Name:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ contactDescription.company_name }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="!contactDescription.satellite_office_id">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Address:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full" v-if="contactDescription.head_office_address_1 || contactDescription.head_office_city || contactDescription.head_office_county">
            {{
              contactDescription.head_office_address_1?contactDescription.head_office_address_1:'' }}
                {{  
                contactDescription.head_office_city?' , ' + contactDescription.head_office_city:'' }}
               {{  
                contactDescription.head_office_county?' , ' + contactDescription.head_office_county:''
            }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="contactDescription.satellite_office_id">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Address:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ contactDescription.selected_satellite_office }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="contactDescription.title">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Title:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ contactDescription.title }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="contactDescription.forename">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Forename:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ contactDescription.forename }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="contactDescription.surname">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Surname:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ contactDescription.surname }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="contactDescription.ddi">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              DDI:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ contactDescription.ddi }}
          </div>
        </div>

        <div class="vx-row mb-6" v-if="contactDescription.job_title.length != 0">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Job Title:
            </span>
          </div>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-for="(job, job_title_key) in contactDescription.job_title"
            :key="job_title_key"
          >
          <p>{{ job.job_title }}</p>
           
          </div>
        </div>
        

        <div class="vx-row mb-6" v-if="contactDescription.seniority.length != 0">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Seniority:
            </span>
          </div>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-for="(senio, seniority_key) in contactDescription.seniority"
            :key="seniority_key"
          >
          <p>{{ senio.seniority }}</p>
           
          </div>
        </div>

        <div class="vx-row mb-6" v-if="contactDescription.role.length != 0">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Role:
            </span>
          </div>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-for="(r, role_key) in contactDescription.role"
            :key="role_key"
          >
          <p>{{ r.role }}</p>
           
          </div>
        </div>

        <div class="vx-row mb-6" v-if="contactDescription.sub_role.length != 0">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Sub Role: 
            </span>
          </div>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-for="(sr, sr_key) in contactDescription.sub_role"
            :key="sr_key"
          >
          <p>{{ sr.sub_role }}</p>
          </div>
        </div>
        <!-- <vs-divider class="m-5" /> -->
        <template
          v-if="
            contactDescription.emails && contactDescription.emails.length > 0
          "
        >
          <div class="vx-row p-5">
            <h6 class="mr-5">
              Email(s)
            </h6>
          </div>
          <div
            class="p-5"
            v-for="(email, email_key) in contactDescription.emails"
            :key="email_key"
          >
            <span class="p-5">
              {{ email.email }}
              <vs-icon v-if="email.primary" icon="loyalty" size="small"
                >P</vs-icon
              >
            </span>
          </div>
          <vs-divider class="m-5" />
        </template>

        <template
          class="p-5"
          v-if="
            contactDescription.social_medias &&
              contactDescription.social_medias.length > 0
          "
        >
          <div class="vx-row p-5">
            <h6 class="mr-5">
              Social Media(s)
            </h6>
          </div>
          <div
            class="p-5"
            v-for="(social_media,
            social_media_key) in contactDescription.social_medias"
            :key="social_media_key"
          >
            <span class="p-5">
              {{ social_media.social_media }} - {{ social_media.summary }}
              <vs-icon v-if="social_media.primary" icon="loyalty" size="small"
                >P</vs-icon
              >
            </span>
          </div>
          <vs-divider class="m-5" />
        </template>
        <template
v-if="
  contactDescription.ddis && contactDescription.ddis.length > 0
"
>
<div class="vx-row p-5">
  <h6 class="mr-5">
    DDI(s)
  </h6>
</div>
<div
  class="p-5"
  v-for="(ddi, ddi_key) in contactDescription.ddis"
  :key="ddi_key"
>


  <span class="p-5" v-if="ddi.ddi">
    {{ ddi.ddi_phone_code }}{{ ddi.ddi }}
    <vs-icon v-if="ddi.primary" icon="loyalty" size="small"
      >P</vs-icon
    >

    <span v-if="ddi.checked_status == 'Registered'" class="tps-registered" style="font-size:20px;" title="TPS Registered">®</span> 

  </span>
</div>
<vs-divider class="m-5" />
</template>

        <template
          v-if="
            contactDescription.mobiles && contactDescription.mobiles.length > 0
          "
        >
          <div class="vx-row p-5">
            <h6 class="mr-5">
              Mobile(s)
            </h6>
          </div>
          <div
            class="p-5"
            v-for="(mobile, mobile_key) in contactDescription.mobiles"
            :key="mobile_key"
          >
          <span class="p-5" v-if="mobile.mobile">
              {{ mobile.mobile_phone_code }}{{ mobile.mobile }}
              <vs-icon v-if="mobile.primary" icon="loyalty" size="small"
                >P</vs-icon
              >
              <span v-if="mobile.checked_status == 'Registered'" class="tps-registered" style="font-size:20px;" title="TPS Registered">®</span> 

            </span>
          </div>
          <vs-divider class="m-5" />
        </template>
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import _ from "lodash";
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";
import vSelect from "vue-select";
export default {
  data() {
    return {
      abilities: null,
      linkedin_show_no: 5,
      website_show_no: 5,
      contactDescription: {}
    };
  },
  components: {
    "v-select": vSelect
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }
    this.init();
  },
  watch: {
    // website_show_no(val) {
    //   if (val) {
    //     this.contactDescription.webShow = this.contactDescription.web.slice(
    //       0,
    //       val
    //     );
    //   }
    // },
    // linkedin_show_no(val) {
    //   if (val) {
    //     this.contactDescription.linkedinShow = this.contactDescription.linkedin.slice(
    //       0,
    //       val
    //     );
    //   }
    // },
    // telephone_show_no(val) {
    //   if (val) {
    //     this.contactDescription.phone = this.contactDescription.phone.slice(
    //       0,
    //       val
    //     );
    //   }
    // },
  },
  mounted() {},
  methods: {
    init() {
      // let contactInfor = atob(this.$route.params.contactInformation);
      // contactInfor = JSON.parse(contactInfor)
      let data = {}
      data.account_id = this.$route.params.account_id
      data.contact_id = this.$route.params.contact_id
      // alert(contactId)
      this.$store
        .dispatch("contactsManagement/fetchContact", data)
        .then(res => {
          this.contactDescription = res.data;
          console.log(this.contactDescription);
          // this.contactDescription.webShow = this.contactDescription.web.slice(
          //   0,
          //   this.website_show_no
          // );
          // this.contactDescription.linkedinShow = this.contactDescription.linkedin.slice(
          //   0,
          //   this.linkedin_show_no
          // );
          // this.contactDescription.phone = this.contactDescription.phone.slice(
          //   0,
          //   this.telephone_show_no
          // );
        })
        .catch(err => {
          console.error(err);
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    editContact() {
      // this.$router.replace("edit/" + this.contactDescription.id);
      let contactId = this.contactDescription.uuid;
      this.$router.push({ path: `edit/${contactId}` });
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
